import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Col, Container, Row } from '@yme/atoms/grid';
import { Image } from '@yme/atoms/image';
import { useWindowSize } from '@yme/common/hooks';
import { IndentWrapper } from '@yme/components/Separator';
import { ButtonLinkWrapper } from '@yme/molecules/buttons';
import { getRTL } from '@yme/selectors/common';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel4, RegularTextLevel5 } from '@yme/tokens/typography';
export function CenteredImage(props) {
    const { image, description, link, isRemoveBottomIndent } = props;
    const { isMobileView } = useWindowSize();
    const isRightToLeft = useSelector(getRTL);
    const imageComponent = useMemo(() => (React.createElement(Image, { src: image?.src, srcSet: image?.srcSet, alt: image?.alt })), [image?.alt, image?.src, image?.srcSet]);
    if (!props?.image?.src) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement(Container, { dataTestId: "image-with-text", isRightToLeft: isRightToLeft },
            React.createElement(Row, { justifyContent: "center" },
                React.createElement(Col, { lg: 8 },
                    React.createElement(FlexWrapper, { gap: "16px", flexDirection: "column" },
                        link ? (React.createElement(ButtonLinkWrapper, { buttonLink: link }, imageComponent)) : (imageComponent),
                        isMobileView ? (React.createElement(RegularTextLevel5, null, description)) : (React.createElement(RegularTextLevel4, null, description))))))));
}
CenteredImage.displayName = 'CenteredImage_AEMComponent';
